import CheckBox from './component'

export default CheckBox
